<script lang="ts">
	import type { Snippet } from "svelte";
	import type { ClassValue } from "svelte/elements";
	import loaderIcon from "@core/assets/icons/loader.svg?raw";
	import type { Country } from "@core/schema/Country.js";
	import type { Currency } from "@core/schema/Currency.js";
	import { selectedCurrency } from "../state/selectedCurrency.svelte.js";
	import { selectedDestinationCountry } from "../state/selectedDestinationCountry.svelte.js";
	import Icon from "./common/Icon.svelte";

	const {
		children,
		class: customClass,
	}: { children: Snippet<[currency: Currency, country: Country | "outsideEu"]>; class: ClassValue } = $props();
</script>

{#if selectedCurrency.current !== undefined && selectedDestinationCountry.current !== null}
	{@render children(selectedCurrency.current, selectedDestinationCountry.current)}
{:else}
	<Icon icon={loaderIcon} class={["animate-[spin_1s_steps(8,_jump-end)_infinite_reverse]", customClass]} />
{/if}
